var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"f-account-t-amount",class:_vm.cClass},[(!_vm.cIsZero)?[(_vm.cReceived)?[_vm._v("+")]:[_vm._v("-")]]:_vm._e(),_c('f-token-value',{attrs:{"value":_vm.amount,"decimals":2,"use-placeholder":false,"no-currency":""}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }